import styled from 'styled-components'

export const NewSiteTabWrapper = styled.div`
  display: flex;
  height: 72px;
  flex-shrink: 0;
`

export const NewSiteTabItem = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  font-weight: 500;
  padding: 0 16px;
  color: ${(p) => {
    if (p.isActive) return '#0aa1f4'
    if (p.disabled) return 'rgba(32, 32, 32, 0.38)'
    return 'rgba(32, 32, 32, 1)'
  }};
  cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};
  pointer-events: ${(p) => (p.disabled ? 'none' : 'auto')};
  border-bottom: ${(p) => {
    return p.isActive ? '2px solid rgba(10, 161, 244, 1)' : '2px solid rgba(255, 255, 255, 1)'
  }};

  :hover {
    color: ${(p) => (p.disabled ? 'rgba(32, 32, 32, 0.38)' : '#0aa1f4')};
  }
`
